<template>
  <div class="pageview-mobile">
    <!-- 搜索区域 -->
    <div class="search-box">
      <van-search
        v-model="queryParams.content"
        placeholder="请输入内容"
        @search="handleQuery"
        @clear="resetQuery"
        shape="round"
        clearable
      />
    </div>

    <!-- 操作按钮 -->
    <div class="action-bar">
      <van-button
        type="primary"
        size="small"
        icon="plus"
        plain
        @click="$refs.addVoice.addCreateForm(userId, userName, platForm)"
      >
        新增
      </van-button>
      <div>
        <van-button size="small" type="info" @click="handleQuery" style="margin-right: 10px;">查询</van-button>
        <van-button size="small" icon="replay" @click="resetQuery">重置</van-button>
      </div>
    </div>

    <!-- 数据列表 -->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <div class="list-card" v-for="item in dataList" :key="item.id">
        <van-cell-group :border="false">
          <van-cell title="用户名" :value="item.userName" />
          <van-cell title="内容" :value="item.content" />

          <!-- 音频播放 -->
          <van-cell title="语音文件" :border="false">
            <template #default>
              <audio
                controls
                class="audio-player"
                :src="item.voiceLink"
                style="width: 100%"
              ></audio>
            </template>
          </van-cell>

          <van-cell title="创建时间" :value="formatDate(item.createTime)" />

          <!-- 操作按钮 -->
          <div class="action-buttons">
            <van-button
              type="primary"
              size="mini"
              icon="down"
              @click="downloadFileWithAuth(item.voiceLink)"
            >
              下载
            </van-button>
            <van-button
              type="danger"
              size="mini"
              icon="delete"
              @click="handleDelete(item)"
            >
              删除
            </van-button>
          </div>
        </van-cell-group>
      </div>
    </van-list>

    <!-- 分页占位 -->
    <div v-if="total === 0" class="empty-state">
      <van-empty description="暂无语音数据" />
    </div>

    <!-- 新增弹窗组件 -->
    <addVoiceVant ref="addVoice" @ok="onAddSuccess" />
  </div>
</template>

<script>
import { getvoiceList, delVoiceSynthesis } from "@/api/index";
import addVoiceVant from "@/views/system/VoiceRecognition/addVoiceVant";
import { Dialog, Toast } from "vant";
import axios from "axios";
export default {
  components: {
    addVoiceVant,
  },
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        platForm: "",
        userId: "",
        content: "",
        type: 2,
      },
      loading: false,
      finished: false,
      total: 0,
      dataList: [],
      userId: "",
      userName: "",
      platForm: "",
      oriApi: "",
    };
  },
  created() {},
  mounted() {
    this.userId = this.$route.query.userId;
    this.userName = this.$route.query.userName;
    this.platForm = this.$route.query.platForm;
    this.oriApi = this.$route.query.oriApi;

    this.queryParams.userId = this.userId;
    this.queryParams.platForm = this.platForm;

    this.loadData();
  },
  methods: {
    // 加载数据（支持分页）
    loadData() {
      this.loading = true;
      getvoiceList(this.queryParams)
        .then((response) => {
          const result = response.data.data;
          const list = result.list || [];

          this.dataList.push(...list);
          this.total = result.total;

          // 更新分页
          this.queryParams.pageNum++;
          if (this.dataList.length >= this.total) {
            this.finished = true;
          }
        })
        .catch(() => {
          Toast.fail("加载失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
formatDate(dateStr) {
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()}`;
},
    // 搜索
    handleQuery() {
      this.resetList();
      this.loadData();
    },

    // 重置搜索
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        platForm: this.platForm,
        userId: this.userId,
        content: "",
        type: 2,
      };
      this.resetList();
      this.loadData();
    },

    // 重置列表状态
    resetList() {
      this.dataList = [];
      this.total = 0;
      this.finished = false;
      this.queryParams.pageNum = 1;
    },

    // 删除
    handleDelete(row) {
      Dialog.confirm({
        title: "确认删除",
        message: `是否确认删除编号为 "${row.id}" 的数据？`,
      })
        .then(() => {
          return delVoiceSynthesis({ id: row.id });
        })
        .then(() => {
          Toast.success("删除成功");
          this.resetList();
          this.loadData();
        })
        .catch(() => {
          // 取消
        });
    },

  async downloadFileWithAuth(voiceLink) {
      const fileUrl = voiceLink; // 需要认证的 URL
      console.log(fileUrl)
      const fileName = "audio.mp3"; // 你期望的文件名
      try {
        // 使用 axios 请求文件，responseType 设置为 'blob'
        const response = await axios.get(fileUrl, {
          responseType: "blob", // 关键：告诉 axios 将响应作为二进制大对象处理
          headers: {
            // 如果需要认证，添加请求头
            // 'Authorization': 'Bearer your-jwt-token-here'
            // 其他可能的头...
          },
        });
        console.log(response);
        // 检查响应状态
        if (response.status === 200) {
          // 创建一个 Blob URL
          const blob = new Blob([response.data], { type: response.data.type });
          console.log(blob);
          const url = window.URL.createObjectURL(blob);
          console.log(url);
          // 创建一个临时的 <a> 标签来触发下载
          const link = document.createElement("a");
          link.href = url;
          link.download = fileName; // 设置下载的文件名
          document.body.appendChild(link);
          link.click();

          // 清理：移除元素并释放 Blob URL
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.$modal.msgSuccess("下载成功");
        } else {
          console.error("下载失败:", response.statusText);
        }
      } catch (error) {
        console.error("下载过程中出错:", error);
        // 处理错误，例如显示错误消息
      }
    },
    // 新增成功回调
    onAddSuccess() {
      this.resetList();
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.pageview-mobile {
  padding: 10px;
  background-color: #f9f9f9;
  min-height: 100vh;
  font-size: 14px;
}

.search-box {
  margin-bottom: 10px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.list-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 12px;
  overflow: hidden;
}

.audio-player {
  margin-top: 6px;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 0;
}

.empty-state {
  margin-top: 40px;
  text-align: center;
  color: #999;
}

/* 时间格式化过滤器（可选） */
</style>